import { Controller } from "@hotwired/stimulus"

class Select extends Controller {
  static targets = ["label", "option"]
  static activeClass = "-active"
  static values = {
    stateless: Boolean,
    options: String,
  }

  connect() {
    if (this.statelessValue) {
      return
    }
    this._initializeOptions()
    const checkedRadioInput = this.element.querySelector("input:checked")
    checkedRadioInput && this._updateLabel(checkedRadioInput.value)
  }

  _initializeOptions() {
    this.options = JSON.parse(this.optionsValue)
  }

  _updateLabel(value) {
    if (!this.hasLabelTarget) {
      return
    }
    if (this.labelTarget.dataset.emptyLabel && !value.length) {
      this.labelTarget.innerText = this.labelTarget.dataset.emptyLabel
    } else {
      this.labelTarget.innerText = this.options[value]
    }
  }

  selectOption(e) {
    if (this.statelessValue) {
      return
    }
    this.optionTargets.forEach((optionElement) => {
      optionElement.classList.remove(Select.activeClass)
    })
    const input = e.target.parentNode
    input.classList.add(Select.activeClass)
    this._updateLabel(e.target.value)
  }

  refresh(e) {
    const value = e.target.value
    window.location.href = `${location.origin}/${value}`
  }
}

export { Select }
